<template>
    <div class="cabinet-content-wrap">
        <header
            class="cabinet-header d-flex align-items-center justify-content-between justify-content-md-start"
        >
            <a
                href="javascript:void(0)"
                class="dashboard__back-link"
                @click="$router.go(-1)"
            ></a>
            <h1 class="h1 cabinet-title pl-3 m-0">Ритейлеры</h1>
            <div class="pr-3 pl-3 pb-1"></div>
        </header>

        <section class="dashboard-list__section pt-2">
            <div class="filters-panel-search dashboard-list__search">
                <label
                    class="filters-panel-search__label"
                    for="filters-panel-search__input"
                    @click="onSearch"
                ></label>
                <input
                    id="filters-panel-search__input"
                    v-model.trim="search"
                    type="text"
                    class="app-input filters-panel-search__input"
                    placeholder="Юридическое лицо или город"
                    @keyup.enter="onSearch"
                />
                <label
                    v-if="search"
                    class="filters-panel-search__clear"
                    for="filters-panel-search__input"
                    @click="onClearSearch"
                ></label>
            </div>

            <div v-if="loading" class="pt-4 mt-3">Loading...</div>

            <div
                v-else-if="!paginatedRetailers.length"
                class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
            >
                <img
                    v-if="!search"
                    src="/img/icons/empty-goods.svg"
                    class="dashboard-empty__img ofi"
                />
                <img
                    v-else
                    src="/img/icons/empty-search.svg"
                    class="dashboard-empty__img dashboard-empty__img--search ofi"
                />
                <div class="dashboard-empty__title pt-5">
                    {{
                        search
                            ? ' По вашему запросу ничего не найдено.'
                            : 'Нет информации.'
                    }}
                </div>
            </div>

            <template v-if="!loading && paginatedRetailers.length">
                <div class="d-flex justify-content-between pt-4 mt-3">
                    <pagination-info :pagination="pagination" />

                    <div class="d-none d-md-flex">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalProducts"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                </div>

                <div class="pt-4">
                    <div
                        v-for="retailer in paginatedRetailers"
                        :key="retailer.id"
                        class="cabinet-table__row f d-flex flex-column flex-md-row align-items-md-center pt-4 pb-4"
                    >
                        <div class="dashboard-list__cell">
                            <div
                                v-if="retailer.is_have_documents"
                                class="dashboard-list__cell-name"
                            >
                                <router-link
                                    v-if="retailer.is_have_documents"
                                    :to="{
                                        name: 'SupplierGlobalRetailersDocs',
                                        params: { id: retailer.id }
                                    }"
                                    class="cabinet__catalog-link dashboard-list__btn"
                                    >{{
                                        retailer.company_name || retailer.name
                                    }}</router-link
                                >
                            </div>
                            <div v-else class="dashboard-list__cell-name">
                                {{ retailer.company_name || retailer.name }}
                            </div>
                            {{ retailer.city }}
                        </div>
                        <div class="ml-md-auto pt-2 pt-md-0">
                            <router-link
                                v-if="retailer.is_have_documents"
                                :to="{
                                    name: 'SupplierGlobalRetailersDocs',
                                    params: { id: retailer.id }
                                }"
                                class="cabinet__catalog-link dashboard-list__btn"
                                >Скачать документы</router-link
                            >
                        </div>
                        <div class="pt-2 pt-md-0">
                            <button
                                class="cabinet-btn cabinet__catalog-button dashboard-list__btn"
                                @click="openMessageModal(retailer)"
                            >
                                Отправить сообщение
                            </button>
                        </div>
                    </div>
                </div>

                <div class="pt-4 pb-5 mb-3">
                    <div class="d-none d-md-flex justify-content-end">
                        <table-pagination
                            :current-page="pagination.page"
                            :total-pages="pagination.totalPages"
                            :total-products="pagination.totalProducts"
                            @setPage="onSetPage($event)"
                        />
                    </div>
                    <div
                        v-if="pagination.page < pagination.totalPages"
                        class="d-flex d-md-none justify-content-center pt-2"
                    >
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default"
                            :disabled="pagination.page >= pagination.totalPages"
                            @click="updateList(pagination.page + 1, true)"
                        >
                            Загрузить еще
                        </button>
                    </div>
                </div>
            </template>
        </section>

        <message-modal
            :is-open="isMessageModalOpen"
            :retailer="selectedRetailer"
            @closeModal="onCloseMessageModal"
            @onSend="onMessageSend"
        />
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import PaginationInfo from '@/components/Cabinet/Pagination/PaginationInfo'
import MessageModal from '@/components/Cabinet/Supplier/Dashboard/MessageModal'

export default {
    name: 'GlobalRetailers',
    components: { TablePagination, PaginationInfo, MessageModal },
    data() {
        return {
            loading: true,
            search: '',
            isMessageModalOpen: false,
            selectedRetailer: {}
        }
    },
    computed: {
        ...mapState('supplierStatsRetailers', [
            'retailers',
            'mobileRetailers',
            'pagination',
            'errors'
        ]),
        paginatedRetailers() {
            if (document.documentElement.clientWidth > 767) {
                return this.retailers
            }
            return this.mobileRetailers
        }
    },
    async mounted() {
        this.updateList(1)
    },
    destroyed() {
        this.clearRetailers()
    },
    methods: {
        ...mapActions('supplierStatsRetailers', [
            'getRetailers',
            'clearRetailers'
        ]),
        ...mapMutations('supplierStatsRetailers', ['SET_PAGINATION']),
        updateList: _.debounce(async function(
            page = 1,
            isMobilePagination = false
        ) {
            let data = { page, isMobilePagination }

            if (this.search) {
                data.search = this.search
            }

            if (isMobilePagination) {
                this.$Progress.start()
            }

            await this.getRetailers(data)

            if (Object.keys(this.errors.getRetailers).length) {
                this.$notify({
                    text: 'Ошибка',
                    type: 'error'
                })
            }
            this.loading = false
        },
        800),
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.$Progress.start()

            this.updateList(page)
        },
        onSearch() {
            this.$Progress.start()
            this.updateList(1)
        },
        onClearSearch() {
            this.search = ''
            this.$Progress.start()
            this.updateList(1)
        },
        openMessageModal(retailer) {
            this.selectedRetailer = retailer
            this.isMessageModalOpen = true
        },
        onCloseMessageModal() {
            this.selectedRetailer = {}
            this.isMessageModalOpen = false
        },
        onMessageSend() {
            console.log('onMessageSend')
        }
    }
}
</script>
